import React from 'react';
import { COLORS } from '../../../../utils/constants';

const InfoRow = ({ label, value, highlight }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: `1px solid ${COLORS.border}20`, backgroundColor: highlight ? `${COLORS.primary}10` : 'transparent' }}>
    <span style={{ color: highlight ? COLORS.primary : COLORS.textSecondary, fontSize: '14px' }}>{label}</span>
    <span style={{ color: COLORS.text, fontSize: '14px', fontWeight: highlight ? '600' : '400' }}>{value}</span>
  </div>
);

const InfoTab = ({ details }) => (
  <div>
    <InfoRow label="Email" value={details?.user?.email} />
    <InfoRow label="Телефон (клиент)" value={details?.user?.phone || '-'} />
    <InfoRow label="Телефон (админ)" value={details?.user?.admin_phone || '-'} highlight />
    <InfoRow label="Имя" value={details?.user?.name || '-'} />
    <InfoRow label="Менеджер" value={details?.user?.manager_name || '-'} />
    <InfoRow label="Язык" value={details?.user?.language || 'ru'} />
    <InfoRow label="Активен" value={details?.user?.is_active ? 'Да' : 'Нет'} />
    <InfoRow label="Регистрация" value={new Date(details?.user?.created_at).toLocaleDateString('ru')} />
    
    <h4 style={{ color: COLORS.text, fontSize: '14px', fontWeight: '600', marginTop: '20px', marginBottom: '12px' }}>
      Кошельки ({details?.wallets?.length || 0})
    </h4>
    {details?.wallets?.length > 0 ? (
      details.wallets.map((w, i) => (
        <div key={i} style={{
          padding: '10px',
          backgroundColor: COLORS.background,
          borderRadius: '8px',
          marginBottom: '8px',
          fontSize: '12px',
          fontFamily: 'monospace',
          color: COLORS.text,
        }}>
          <div style={{ color: COLORS.textSecondary, marginBottom: '4px' }}>{w.chain}</div>
          {w.address}
        </div>
      ))
    ) : (
      <div style={{ color: COLORS.textSecondary, fontSize: '13px' }}>Нет подключенных кошельков</div>
    )}
  </div>
);

export default InfoTab;
